import * as FormMessages from "../../constants/FormMessages";
import { _prettyPhone } from "./dataConversion";
export function getPreferredPhoneError(preferredPhone, profile) {
    if (!preferredPhone || preferredPhone === "Unspecified") {
        return FormMessages.ERRORS.SELECT;
    }
    const key = `phone${preferredPhone[0].toUpperCase()}${preferredPhone.substr(1)}`;
    if (profile[key]) {
        return null;
    }
    return "Please select a valid option";
}
export function getPhone(profile) {
    let phone;
    switch (profile.preferredPhone.toLowerCase()) {
        case "home":
            phone = profile.phoneHome;
            break;
        case "cell":
            phone = profile.phoneCell;
            break;
        case "work":
            phone = profile.phoneWork;
            break;
    }
    if (!phone) {
        // if their preferred phone is blank take the first truthy
        phone = [profile.phoneHome, profile.phoneCell, profile.phoneWork].find(Boolean) || "";
    }
    return _prettyPhone(phone);
}
export function getFullName(profile) {
    return [profile.firstName, profile.lastName]
        .filter(Boolean)
        .map(it => it.trim())
        .join(" ");
}



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/profile/utils.ts